import { Interview } from "../models/Interview";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const editInterview = async (interview: Interview) => {
  try {
    const response = await fetchWithAuthentication(
      "/interviews",
      "PUT",
      interview,
    );

    if (response.ok) {
      const interviewId = response.text;
      console.log(interviewId);
      return interviewId;
    } else {
      console.error("Failed to save data:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getInterviewById = async (interviewId: string) => {
  try {
    const response = await fetchWithAuthentication(
      `/interview?interviewId=${interviewId}`,
      "GET",
      null,
    );
    if (response.ok) {
      return response.json();
    } else {
      console.error("Failed to get interview by:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getActiveInterviews = async (
  setLoading: (newValue: boolean) => void,
  pageNum: number,
  setTotalPages: (newValue: number) => void,
): Promise<Interview[]> => {
  setLoading(true);
  const pageSize = 9;

  if (pageNum === 0) {
    setLoading(false);
    return [];
  }

  try {
    const response = await fetchWithAuthentication(
      `/interviews?pageNum=${pageNum}&pageSize=${pageSize}&feedbackSubmitted=false`,
      "GET",
      null,
    );
    const data = await response.json();
    setTotalPages(data.pageTotal);
    return data.interviews || [];
  } catch (error) {
    console.error("Error fetching interviews or transcriptions:", error);
    return [];
  } finally {
    setLoading(false);
  }
};

export const getSubmittedInterviews = async (
  setLoading: (newValue: boolean) => void,
  pageNum: number,
  setTotalPages: (newValue: number) => void,
): Promise<Interview[]> => {
  setLoading(true);
  const pageSize = 9;

  if (pageNum === 0) {
    setLoading(false);
    return [];
  }

  try {
    const response = await fetchWithAuthentication(
      `/interviews?pageNum=${pageNum}&pageSize=${pageSize}&feedbackSubmitted=true`,
      "GET",
      null,
    );
    const data = await response.json();
    setTotalPages(data.pageTotal);
    return data.interviews || [];
  } catch (error) {
    console.error("Error fetching interviews or transcriptions:", error);
    return [];
  } finally {
    setLoading(false);
  }
};
